import { mailListItemAnimationStore } from '../store/Store';
import { ActionId } from './actionId';
import { setAnimationAction } from '../actions/setAnimationAction';

export function startAnimatedAction(
    actionId: ActionId,
    rowKeys: string[],
    handleAnimation?: () => void
) {
    !mailListItemAnimationStore.animationAction && // if there is an animation in progress, do a no op
        setAnimationAction(actionId /*actionId*/, rowKeys, handleAnimation);
}
